
import { AppDispatch } from "@/redux"
import { appActions } from "@/redux/slice/appSlice"
import { ApplicationsAPI } from "@/API/Applications"
import { applicationsActions } from "@/redux/slice/applicationsSlice"
import { AppAvailabilityStatus } from "@/constants/TCS/TCS"
import { showNotification } from "./notificationService"
import { FetchFilterChoicesRequestBody } from "@/types/WorkflowCreate/filters"
import { formattedWorkflowMessage } from "@/constants/workflows/workflows"
import { Filter, Option } from "@/types/WorkflowCreate/fields"
import { AppOptions, OptionDependency } from "@/types/WorkflowCreate/options"
import { ActionSubjectOption } from "@/types/WorkflowCreate/AppConfiguration"

export const getAllApplications = (
  token: string
) => async (dispatch: AppDispatch) => {
  dispatch(appActions.setLoading(true))
  const resp = await ApplicationsAPI.getAll(token)
  if (resp.data?.apps) {
    dispatch(applicationsActions.setAvailableTCSApplications(
      resp.data.apps.sort((a,) => a.status === AppAvailabilityStatus.ACTIVE ? -1 : 1)
    )
    )
  }
  dispatch(appActions.setLoading(false))
  return resp
}

export const getLoginMethodsOfApp = (
  token: string,
  appId: string
) => async (dispatch: AppDispatch) => {
  dispatch(appActions.setLoading(true))
  const resp = await ApplicationsAPI.getLoginMethodsOfApp(token, appId)
  dispatch(appActions.setLoading(false))
  return resp
}

export const getActionsAndSubjectsByApp = (
  token: string,
  appId: string
) => async (dispatch: AppDispatch) => {
  dispatch(appActions.setLoading(true))
  const resp = await ApplicationsAPI.getAvailableSubjects(
    token,
    appId
  )
  dispatch(appActions.setLoading(false))
  return resp
}

export const getAvailableFiltersWithChoices = (
  token: string,
  appId: string,
  body: FetchFilterChoicesRequestBody
) => async (dispatch: AppDispatch) => {
  dispatch(appActions.setLoading(true))
  const resp = await ApplicationsAPI.getAvailableFiltersWithChoices(
    token,
    appId,
    body
  )
  if (!resp.data) {
    showNotification({ data: undefined, err: resp.err }, '', formattedWorkflowMessage)
  }
  dispatch(appActions.setLoading(false))
  return resp
}

export const getAppAvailableFields = (
  token: string,
  action: string,
  subject: string,
  credentialId: string,
  appId: string,
  filters: Filter[],
  options: Option[],
) => async (dispatch: AppDispatch) => {
  dispatch(appActions.setLoading(true))
  const resp = await ApplicationsAPI.getAppAvailableFields(
    token,
    appId,
    {
      action,
      subject,
      credentialId,
      filters,
      options
    }
  )
  dispatch(appActions.setLoading(false))
  return resp
}

export const getAppAvailableOptions = (
  token: string,
  appId: string,
  credentialId: string,
  action: string,
  subject: string,
  optionDependencies: OptionDependency[],
  actionSubjectOptions: ActionSubjectOption[]
) => async (dispatch: AppDispatch) => {
  dispatch(appActions.setLoading(true))

  const errorMessages: string[] = []
  const appOptions: AppOptions[] = []

  for (let i = 0; i < actionSubjectOptions.length; i++) {
    const resp = await ApplicationsAPI.getAvailableOptionsWithChoices(
      token,
      appId,
      {
        action,
        subject,
        credentialId,
        optionDependencies,
        options: [actionSubjectOptions[i]?.code]
      }
    )
    if (resp.data) {
      appOptions.push({
        ...actionSubjectOptions[i],
        optionValues: resp.data.find(d => d.optionCode === actionSubjectOptions[i]?.code)?.values || []
      })
    } else if (resp.err && !errorMessages.includes(resp.err)) {
      errorMessages.push(resp.err)
    }
  }

  if (errorMessages.length) {
    showNotification({ data: undefined, err: errorMessages.join('. ') }, '', formattedWorkflowMessage)
  }

  dispatch(appActions.setLoading(false))
  return appOptions.sort((a, b) => a.order - b.order)
}
